import React, { FunctionComponent } from 'react'
import { ClearingHouseInteraction, DealDetail } from 'api'
import styled from '@emotion/styled'
import { createStructuredSelector } from 'reselect'
import { createClearingHouseInteractionsForDealSelector } from 'selectors/clearingSelectors'
import { connect } from 'react-redux'
import { CollapsePanel } from 'view/components/panels'
import { Locale, Translation } from 'locale'
import { ClearingHouseInteractionGrid } from './ClearingHouseInteractionGrid'

type ClearingInfoPanelProps = OwnProps & StateProps

interface OwnProps {
  dealDetail: DealDetail
}

interface StateProps {
  interactions: ClearingHouseInteraction[]
}

interface DispatchProps {}

const dealIdSelector = (_: {}, props: ClearingInfoPanelProps) => props.dealDetail.deal.dealId

const mapStateToProps = createStructuredSelector({
  interactions: createClearingHouseInteractionsForDealSelector(dealIdSelector)
})

const Wrapper = styled.div`
  height: 200px;
  padding-left: 10px;
  overflow: none;
`

const ClearingHouseDealTicketPanelComponent: FunctionComponent<ClearingInfoPanelProps> = props => {
  const { interactions } = props
  return (
    <CollapsePanel title={Locale.translate(Translation.TC_TICKET_SWIFT_INTERACTIONS)}>
      <Wrapper>
        <ClearingHouseInteractionGrid interactions={interactions} />
      </Wrapper>
    </CollapsePanel>
  )
}

export const ClearingHouseDealTicketPanel = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(
  ClearingHouseDealTicketPanelComponent
)
